import * as yup from "yup";

// 🔢 Number Field
const numberField = ({
  requiredMsg,
  typeMsg,
  min,
  max,
  minMsg,
  maxMsg,
} = {}) => {
  let schema = yup
    .number()
    .typeError(typeMsg)
    .required(requiredMsg);

  if (min !== undefined) {
    schema = schema.min(min, minMsg);
  }

  if (max !== undefined) {
    schema = schema.max(max, maxMsg);
  }

  return schema;
};

// 🧵 String Field
const stringField = ({ requiredMsg } = {}) =>
  yup.string().required(requiredMsg);

// 🏭 Factory (inject t once)
export const createValidators = (t) => ({
  number: (options = {}) =>
    numberField({
      requiredMsg: t("thisFieldIsRequired"),
      typeMsg: t("thisFieldMustBeANumber"),
      minMsg:
        options.min !== undefined
          ? t("minValue", { value: options.min })
          : undefined,
      maxMsg:
        options.max !== undefined
          ? t("maxValue", { value: options.max })
          : undefined,
      ...options,
    }),

  string: () =>
    stringField({
      requiredMsg: t("thisFieldIsRequired"),
    }),
});